var openUploadWidget = function openUploadWidget(options, callback) {
  return typeof window !== 'undefined' && window.cloudinary.openUploadWidget(options, callback);
};

export default openUploadWidget;